import { Input } from '@mui/joy';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { formatDateForDatabase } from '@utils/dates';
import { isValid } from 'date-fns';
import { forwardRef } from 'react';
import { MaterialThemeWrapper } from "theme";

export const DatePicker = forwardRef(function DatePicker(props, ref) {
    let {value, ...restProps} = props;
    if(value && isValid(value)) {
        value = formatDateForDatabase(value);
    }

    return (
        <Input
            variant="outlined"
            ref={ref}
            type={'date'}
            value={value}
            {...restProps}
        />
    )
});

/**
 * This is disbled for now because it causes *extreme* performance issues on volunteer hour edit
 *
 * @deprecated
 */
const DatePicker_Disabled = forwardRef(function DatePicker(props, ref) {
    return (
        <MaterialThemeWrapper>
            <MUIDatePicker
                slotProps={{ field: { clearable: true } }}
                ref={ref}
                /*
                id={name}
                formatDensity="spacious"
                slotProps={{
                    field: {
                    clearable: true,
                    },
                }}
                onChange={(value) => {
                    if(value) {
                    value = formatDateForDatabase(value);
                    }
                    onChange(value);
                }}
                {...fieldProps}
                */
                {...props}
            />
        </MaterialThemeWrapper>
    );
});
